import React from 'react';
import Dialog from '@/presentation/reusables/Dialog';
import DialogExtraCaption from '@/presentation/reusables/Dialog/extras/caption';
import errorImage from '../../../../assets/illustrations/error-files.svg';

interface IProps {
  handlerReopen: () => void;
  handlerClose: () => void;
  message: string;
  title?: string;
}

const FailedPaymentModal = ({
  handlerReopen,
  handlerClose,
  message,
  title
}: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={!!message}
    zIndex={10000}
    textButtonA="Volver a Intentar"
    handlerButtonA={() => {
      handlerClose();
      handlerReopen();
    }}
    img={errorImage}
  >
    <DialogExtraCaption
      title={title ?? 'Tu pago fue rechazado'}
      subtitle={message}
    />
  </Dialog>
);

export default FailedPaymentModal;
